
class ProductStickyCTA extends HTMLElement {
    constructor() {
      super();     
      this.bindEvents();
    }

    bindEvents() { 
       const ctaButtonElement = this.querySelector("cta-cart");
       ctaButtonElement?.addEventListener("click", this.onCTAClick.bind(this));

       window.addEventListener('scroll', this.enableStickyCTA.bind(this));
    }

    onCTAClick() {
        const trueCTAButton = document.querySelector(".product__information cta-cart") as HTMLElement;
        trueCTAButton.click();
    }

    enableStickyCTA(event: Event) {
        const ctaElement = document.querySelector(".product__information .product__cta-group");
        const offset = ctaElement?.getBoundingClientRect().top;

        if(offset && offset < 90) {
            this.classList.add('active');
        }
        else {
            this.classList.remove('active');
        }
    }
  
}
  
customElements.define('product-sticky-cta', ProductStickyCTA);